(function () {
    'use strict';
    angular.module('wamasysApp').component('equipmentPosition', {
        bindings: {model: '='},
        template: '<map-leaflet contrat="$ctrl.position" height="360px" width="100%"></map-leaflet>',
        controller: ['$scope', function ($scope) {
            var ctrl = this;
            ctrl.$onInit = function () {
                ctrl.position = {lat: ctrl.model.latitude, lon: ctrl.model.longitude};
                $scope.$watchGroup(['$ctrl.model.latitude', '$ctrl.model.longitude'], function (values) { ctrl.position.lat = values[0]; ctrl.position.lon = values[1]; });
                $scope.$watchGroup(['$ctrl.position.lat', '$ctrl.position.lon'], function (values) { ctrl.model.latitude = values[0]; ctrl.model.longitude = values[1]; });
            };
        }]
    });
})();
